import AuthenticationLayout from 'components/AuthLayout';
import Button from 'components/Button';
import CopyText from 'components/CopyText';
import SuccessIcon from 'components/icons/Success';
import Space from 'components/Space';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Text = styled.p`
  margin-top: 1rem;
  width: 100%;
  a {
    text-decoration: underline;
    color: var(--primary-600);
  }
`;

const ButtonContainer = styled.div`
  button {
    margin-left: auto;
    margin-right: auto;
    padding: 0.7rem 1.1rem;
  }
`;

const ChartSigned: FC = () => {
  return (
    <AuthenticationLayout
      title="Merci d'avoir complété le formulaire et signé la charte"
      icon={<SuccessIcon />}
      src_image="/logo_institut_mentorat.png"
    >
      <Text>
        Nous allons revenir vers vous très vite pour vous proposer un mentor.
      </Text>
      <Text>
        Pensez à vérifier régulièrement votre boîte mail (et vos spams) pour ne
        rien manquer !
      </Text>
      <Text>
        En attendant, pour mieux comprendre ce qu'est le mentorat, nous vous
        invitons à compléter{' '}
        <a
          href="https://docs.google.com/forms/d/e/1FAIpQLSdNMLKDcskqjfURjs4nHY04chHFFLK9NigZLbN2bC-XLcz2fA/viewform?usp=sf_link"
          target="_blank"
          rel="noreferrer"
          style={{}}
        >
          notre quiz de présentation
        </a>{' '}
        !
      </Text>
      <Text>
        Vous pouvez également nous contacter à l'adresse suivante pour toute
        question :
      </Text>
      <Space height={1} />
      <CopyText text="mentorat@engagement.fr" />
      <Space height={3} />
      <ButtonContainer>
        <Link to="/">
          <Button color="primary">Retourner à l'accueil</Button>
        </Link>
      </ButtonContainer>
    </AuthenticationLayout>
  );
};

export default ChartSigned;
